// Legal content (Terms, Privacy, Contact) for ES / EN / SK.
// Each section is rendered as: <h2>title</h2><p>paragraph</p>...
// Updates here only — pages read structure dynamically.

export const LEGAL_META = {
  contact_email: "rebelbtc@rebelbtc.com",
  website: "www.rebelbtc.com",
  last_updated: "May 2026",
  entity: "RE₿EL BTC",
};

export const LEGAL = {
  es: {
    common: {
      back_home: "Volver al inicio",
      last_updated: "Última actualización",
      contact_us: "Contacta con nosotros",
      table_of_contents: "Tabla de contenidos",
      legal_eyebrow: "Documento legal",
      educational_disclaimer: "RE₿EL BTC ofrece exclusivamente contenido educativo. No es asesoramiento financiero.",
    },
    terms: {
      title: "Términos y Condiciones",
      subtitle: "Condiciones de uso de la plataforma RE₿EL BTC, la Academia RE₿EL y el Mentor IA.",
      sections: [
        {
          id: "educational-purpose",
          title: "1. Finalidad Educativa",
          paragraphs: [
            "RE₿EL BTC es una plataforma educativa centrada en mercados de criptoactivos, blockchain, análisis técnico y gestión de riesgo. Todo el contenido —lecciones, gráficos, materiales del Mentor IA y artículos— se proporciona exclusivamente con fines informativos y formativos.",
            "El uso de la plataforma no constituye consultoría de inversión, recomendación personalizada ni oferta de compraventa de instrumentos financieros o activos digitales.",
          ],
        },
        {
          id: "risk-disclaimer",
          title: "2. Aviso de Riesgo",
          paragraphs: [
            "El trading y la inversión en criptoactivos conllevan un alto nivel de riesgo y pueden resultar en la pérdida total del capital. La volatilidad de estos mercados es elevada y los rendimientos pasados no garantizan resultados futuros.",
            "Cada usuario opera bajo su propio criterio, responsabilidad y riesgo. RE₿EL BTC no garantiza beneficios ni protege contra pérdidas.",
          ],
        },
        {
          id: "user-accounts",
          title: "3. Cuentas de Usuario",
          paragraphs: [
            "Para acceder a determinadas funciones (Academia, Mentor IA, Audio Onyx) es necesario crear una cuenta proporcionando un email válido y una contraseña, o autenticándose mediante Google.",
            "El usuario es responsable de la confidencialidad de sus credenciales y de toda actividad realizada bajo su cuenta. Notifica inmediatamente cualquier acceso no autorizado a rebelbtc@rebelbtc.com.",
          ],
        },
        {
          id: "premium-features",
          title: "4. Funciones Premium",
          paragraphs: [
            "La plataforma sigue un modelo freemium. Las 51 lecciones de la Academia RE₿EL son gratuitas. El Mentor IA y la lectura por voz Onyx incluyen una (1) prueba gratuita de por vida por cuenta.",
            "Para acceso ilimitado a estas funciones es necesario adquirir la licencia RE₿EL PRO de pago único de 39,90 €.",
          ],
        },
        {
          id: "payments",
          title: "5. Pagos",
          paragraphs: [
            "Los pagos se procesan a través de Stripe, proveedor PCI-DSS certificado. RE₿EL BTC no almacena datos de tarjetas en sus servidores.",
            "Al completar el pago el usuario recibe acceso inmediato y permanente (lifetime) a las funciones PRO contratadas, vinculado a su cuenta.",
          ],
        },
        {
          id: "refund-policy",
          title: "6. Política de Reembolso",
          paragraphs: [
            "Dada la naturaleza digital y de acceso inmediato del producto, los pagos no son reembolsables una vez activada la licencia PRO.",
            "Si experimentas un problema técnico que impida el acceso al servicio adquirido, contáctanos en rebelbtc@rebelbtc.com en un plazo de 14 días desde la compra para evaluar el caso.",
          ],
        },
        {
          id: "intellectual-property",
          title: "7. Propiedad Intelectual",
          paragraphs: [
            "Todo el contenido de la plataforma —textos, gráficos, lecciones, código, marca RE₿EL y diseños— es propiedad de RE₿EL BTC y está protegido por las leyes internacionales de propiedad intelectual.",
            "Queda prohibida la reproducción, distribución, modificación o reutilización comercial sin autorización expresa por escrito.",
          ],
        },
        {
          id: "ai-mentor",
          title: "8. Aviso del Mentor IA",
          paragraphs: [
            "El Mentor IA es un asistente educativo automatizado basado en modelos de lenguaje. Sus respuestas pueden contener errores, imprecisiones o información desactualizada.",
            "Bajo ninguna circunstancia el Mentor IA constituye asesoramiento financiero, legal o fiscal. El usuario debe validar la información con fuentes oficiales y profesionales acreditados antes de tomar decisiones.",
          ],
        },
        {
          id: "platform-availability",
          title: "9. Disponibilidad de la Plataforma",
          paragraphs: [
            "RE₿EL BTC se esfuerza por mantener el servicio disponible 24/7, pero no garantiza ausencia total de interrupciones, mantenimiento programado o incidencias técnicas.",
            "Nos reservamos el derecho a modificar, suspender o discontinuar funciones de la plataforma con notificación razonable.",
          ],
        },
        {
          id: "limitation-liability",
          title: "10. Limitación de Responsabilidad",
          paragraphs: [
            "En la máxima medida permitida por la legislación aplicable, RE₿EL BTC no se hace responsable de pérdidas directas, indirectas, incidentales o consecuentes derivadas del uso de la plataforma, del Mentor IA o de decisiones de inversión.",
            "El uso de la plataforma se realiza bajo el riesgo exclusivo del usuario.",
          ],
        },
        {
          id: "modifications",
          title: "11. Modificaciones de los Términos",
          paragraphs: [
            "RE₿EL BTC puede actualizar estos Términos en cualquier momento. La fecha de última actualización se indica al inicio del documento.",
            "El uso continuado de la plataforma tras la publicación de cambios constituye aceptación de los nuevos términos.",
          ],
        },
        {
          id: "contact-info",
          title: "12. Información de Contacto",
          paragraphs: [
            "Para cualquier consulta relacionada con estos Términos, escríbenos a rebelbtc@rebelbtc.com o visita www.rebelbtc.com.",
          ],
        },
      ],
    },
    privacy: {
      title: "Política de Privacidad",
      subtitle: "Cómo recogemos, usamos y protegemos tus datos personales en RE₿EL BTC.",
      sections: [
        {
          id: "info-collected",
          title: "1. Información que Recogemos",
          paragraphs: [
            "Recogemos únicamente los datos estrictamente necesarios para ofrecer el servicio: email, nombre opcional, foto de perfil (si te autenticas con Google), progreso en la Academia y consultas dirigidas al Mentor IA.",
            "No recopilamos datos sensibles ni información de tarjetas de crédito —esta última es gestionada exclusivamente por Stripe.",
          ],
        },
        {
          id: "account-data",
          title: "2. Datos de Cuenta",
          paragraphs: [
            "Tu cuenta almacena: email, contraseña cifrada (bcrypt), nombre, foto de perfil, estado PRO/FREE, lecciones completadas y contadores de uso del trial.",
            "Estos datos se conservan mientras tu cuenta esté activa y pueden eliminarse a petición.",
          ],
        },
        {
          id: "payments-stripe",
          title: "3. Procesamiento de Pagos vía Stripe",
          paragraphs: [
            "Todos los pagos se procesan a través de Stripe Inc., proveedor certificado PCI-DSS nivel 1. Stripe recibe los datos de tarjeta directamente desde el navegador del usuario; RE₿EL BTC nunca tiene acceso a ellos.",
            "Stripe procesa los datos conforme a su propia política de privacidad: https://stripe.com/privacy",
          ],
        },
        {
          id: "ai-mentor-data",
          title: "4. Uso de Datos del Mentor IA",
          paragraphs: [
            "Los mensajes enviados al Mentor IA se procesan a través de modelos de lenguaje proporcionados por Anthropic (Claude) bajo nuestra clave Emergent.",
            "Los mensajes se almacenan en nuestra base de datos vinculados a tu cuenta exclusivamente para mantener el historial de conversación dentro de la sesión. No se utilizan para entrenar modelos externos.",
          ],
        },
        {
          id: "cookies-analytics",
          title: "5. Cookies y Analítica",
          paragraphs: [
            "Usamos cookies estrictamente necesarias para la sesión (token JWT httpOnly) y para recordar tu idioma preferido.",
            "Podemos usar analítica agregada (sin identificar usuarios individuales) para mejorar la plataforma. No vendemos ni cedemos datos a terceros con fines publicitarios.",
          ],
        },
        {
          id: "data-protection",
          title: "6. Protección de Datos",
          paragraphs: [
            "Tratamos tus datos conforme al RGPD (Reglamento (UE) 2016/679) y demás normativa aplicable. La base legal del tratamiento es el consentimiento (registro) y la ejecución del contrato (servicio PRO).",
          ],
        },
        {
          id: "third-parties",
          title: "7. Servicios de Terceros",
          paragraphs: [
            "RE₿EL BTC se apoya en proveedores cualificados: Stripe (pagos), Anthropic vía Emergent LLM (Mentor IA), OpenAI vía Emergent LLM (síntesis de voz Onyx), Google (autenticación opcional) y MongoDB (almacenamiento).",
            "Cada uno aplica sus propias garantías de seguridad y privacidad.",
          ],
        },
        {
          id: "user-rights",
          title: "8. Derechos del Usuario",
          paragraphs: [
            "Tienes derecho a acceder, rectificar, suprimir, portar y oponerte al tratamiento de tus datos. Para ejercerlos escríbenos a rebelbtc@rebelbtc.com.",
            "También puedes presentar reclamación ante la autoridad de control competente (en España, la AEPD).",
          ],
        },
        {
          id: "data-security",
          title: "9. Seguridad de los Datos",
          paragraphs: [
            "Aplicamos cifrado en tránsito (HTTPS/TLS), contraseñas hash con bcrypt, cookies httpOnly seguras y autenticación JWT con expiración.",
            "Aunque no existe sistema 100% inviolable, mantenemos medidas técnicas y organizativas razonables conforme al estado del arte.",
          ],
        },
        {
          id: "changes",
          title: "10. Cambios en la Política de Privacidad",
          paragraphs: [
            "Esta política puede actualizarse periódicamente. Notificaremos cambios sustanciales por email o mediante un aviso en la plataforma.",
          ],
        },
        {
          id: "contact-info",
          title: "11. Información de Contacto",
          paragraphs: [
            "Responsable del tratamiento: RE₿EL BTC · Email: rebelbtc@rebelbtc.com · Web: www.rebelbtc.com",
          ],
        },
      ],
    },
    contact: {
      title: "Contacto",
      subtitle: "Estamos para ayudarte. Escríbenos a través del email de soporte y te responderemos en menos de 48 horas hábiles.",
      email_label: "Email de Soporte",
      response_label: "Tiempo de respuesta",
      response_time: "Menos de 48 horas hábiles",
      website_label: "Web",
      categories_title: "Categorías de Soporte",
      categories: [
        { title: "Soporte de la Academia", desc: "Dudas sobre lecciones, quizzes y contenidos del curso." },
        { title: "Soporte del Mentor IA", desc: "Incidencias con el Mentor IA Claude Sonnet 4.5 o el flujo de chat." },
        { title: "Soporte de Pagos", desc: "Consultas sobre tu compra PRO, facturación o problemas con Stripe." },
        { title: "Soporte Técnico", desc: "Errores, bugs, problemas de acceso o sugerencias de mejora." },
      ],
      cta_label: "Enviar un Email",
      disclaimer: "RE₿EL BTC ofrece exclusivamente contenido educativo. No es asesoramiento financiero.",
    },
  },

  en: {
    common: {
      back_home: "Back to home",
      last_updated: "Last updated",
      contact_us: "Contact us",
      table_of_contents: "Table of contents",
      legal_eyebrow: "Legal document",
      educational_disclaimer: "RE₿EL BTC provides educational content only. Not financial advice.",
    },
    terms: {
      title: "Terms & Conditions",
      subtitle: "Terms governing the use of the RE₿EL BTC platform, RE₿EL Academy, and the AI Mentor.",
      sections: [
        {
          id: "educational-purpose",
          title: "1. Educational Purpose Only",
          paragraphs: [
            "RE₿EL BTC is an educational platform focused on crypto-asset markets, blockchain, technical analysis and risk management. All content — lessons, charts, AI Mentor responses and articles — is provided strictly for informational and educational purposes.",
            "Use of the platform does not constitute investment advice, personalised recommendation or an offer to buy or sell any financial instrument or digital asset.",
          ],
        },
        {
          id: "risk-disclaimer",
          title: "2. Risk Disclaimer",
          paragraphs: [
            "Trading and investing in crypto-assets carries a high level of risk and can result in the total loss of your capital. These markets are highly volatile and past performance does not guarantee future results.",
            "Every user trades at their own discretion, responsibility and risk. RE₿EL BTC does not guarantee profits and does not protect against losses.",
          ],
        },
        {
          id: "user-accounts",
          title: "3. User Accounts",
          paragraphs: [
            "To access certain features (Academy, AI Mentor, Onyx Audio) you must create an account using a valid email and password, or by authenticating via Google.",
            "You are responsible for the confidentiality of your credentials and for all activity under your account. Notify any unauthorised access immediately to rebelbtc@rebelbtc.com.",
          ],
        },
        {
          id: "premium-features",
          title: "4. Premium Features",
          paragraphs: [
            "The platform operates on a freemium model. The 51 lessons of RE₿EL Academy are free. The AI Mentor and Onyx voice reading include one (1) lifetime free trial per account.",
            "Unlimited access to these features requires a one-time RE₿EL PRO licence of €39.90.",
          ],
        },
        {
          id: "payments",
          title: "5. Payments",
          paragraphs: [
            "Payments are processed by Stripe, a PCI-DSS certified provider. RE₿EL BTC does not store card data on its servers.",
            "Upon successful payment the user receives immediate, permanent (lifetime) access to the PRO features purchased, tied to their account.",
          ],
        },
        {
          id: "refund-policy",
          title: "6. Refund Policy",
          paragraphs: [
            "Given the digital nature and instant access of the product, payments are non-refundable once the PRO licence has been activated.",
            "If you experience a technical issue preventing access to the purchased service, contact rebelbtc@rebelbtc.com within 14 days of purchase so we can assess the case.",
          ],
        },
        {
          id: "intellectual-property",
          title: "7. Intellectual Property",
          paragraphs: [
            "All content on the platform — texts, graphics, lessons, code, RE₿EL brand and designs — is property of RE₿EL BTC and is protected under international intellectual property laws.",
            "Reproduction, distribution, modification or commercial reuse without express written authorisation is prohibited.",
          ],
        },
        {
          id: "ai-mentor",
          title: "8. AI Mentor Disclaimer",
          paragraphs: [
            "The AI Mentor is an automated educational assistant based on language models. Its responses may contain errors, inaccuracies or outdated information.",
            "Under no circumstances does the AI Mentor constitute financial, legal or tax advice. Users must validate information with official sources and accredited professionals before making decisions.",
          ],
        },
        {
          id: "platform-availability",
          title: "9. Platform Availability",
          paragraphs: [
            "RE₿EL BTC strives to keep the service available 24/7 but does not guarantee absolute absence of interruptions, scheduled maintenance or technical incidents.",
            "We reserve the right to modify, suspend or discontinue platform features with reasonable notice.",
          ],
        },
        {
          id: "limitation-liability",
          title: "10. Limitation of Liability",
          paragraphs: [
            "To the maximum extent permitted by applicable law, RE₿EL BTC is not liable for direct, indirect, incidental or consequential losses arising from use of the platform, the AI Mentor or any investment decision.",
            "Use of the platform is at the user's sole risk.",
          ],
        },
        {
          id: "modifications",
          title: "11. Modifications to Terms",
          paragraphs: [
            "RE₿EL BTC may update these Terms at any time. The last-updated date is indicated at the top of the document.",
            "Continued use of the platform after changes are published constitutes acceptance of the new terms.",
          ],
        },
        {
          id: "contact-info",
          title: "12. Contact Information",
          paragraphs: [
            "For any question relating to these Terms, write to rebelbtc@rebelbtc.com or visit www.rebelbtc.com.",
          ],
        },
      ],
    },
    privacy: {
      title: "Privacy Policy",
      subtitle: "How we collect, use and protect your personal data at RE₿EL BTC.",
      sections: [
        {
          id: "info-collected",
          title: "1. Information We Collect",
          paragraphs: [
            "We collect only the data strictly necessary to deliver the service: email, optional name, profile picture (if you sign in with Google), Academy progress and queries sent to the AI Mentor.",
            "We do not collect sensitive personal data or credit card information — the latter is handled exclusively by Stripe.",
          ],
        },
        {
          id: "account-data",
          title: "2. Account Data",
          paragraphs: [
            "Your account stores: email, hashed password (bcrypt), name, profile picture, PRO/FREE status, completed lessons and trial usage counters.",
            "These data are kept while your account is active and may be deleted on request.",
          ],
        },
        {
          id: "payments-stripe",
          title: "3. Payment Processing via Stripe",
          paragraphs: [
            "All payments are processed by Stripe Inc., a PCI-DSS Level 1 certified provider. Stripe receives card data directly from the user's browser; RE₿EL BTC never has access to it.",
            "Stripe handles the data under its own privacy policy: https://stripe.com/privacy",
          ],
        },
        {
          id: "ai-mentor-data",
          title: "4. AI Mentor Data Usage",
          paragraphs: [
            "Messages sent to the AI Mentor are processed via language models provided by Anthropic (Claude) under our Emergent LLM key.",
            "Messages are stored in our database tied to your account exclusively to maintain conversation history within the session. They are not used to train external models.",
          ],
        },
        {
          id: "cookies-analytics",
          title: "5. Cookies & Analytics",
          paragraphs: [
            "We use strictly necessary cookies for session (httpOnly JWT token) and to remember your preferred language.",
            "We may use aggregated analytics (without identifying individual users) to improve the platform. We do not sell or share data with third parties for advertising.",
          ],
        },
        {
          id: "data-protection",
          title: "6. Data Protection",
          paragraphs: [
            "We process your data in accordance with the GDPR (Regulation (EU) 2016/679) and other applicable regulations. The legal basis is consent (registration) and contract performance (PRO service).",
          ],
        },
        {
          id: "third-parties",
          title: "7. Third-Party Services",
          paragraphs: [
            "RE₿EL BTC relies on qualified providers: Stripe (payments), Anthropic via Emergent LLM (AI Mentor), OpenAI via Emergent LLM (Onyx voice synthesis), Google (optional authentication) and MongoDB (storage).",
            "Each applies its own security and privacy guarantees.",
          ],
        },
        {
          id: "user-rights",
          title: "8. User Rights",
          paragraphs: [
            "You have the right to access, rectify, delete, port and object to the processing of your data. To exercise them write to rebelbtc@rebelbtc.com.",
            "You may also lodge a complaint with the competent supervisory authority.",
          ],
        },
        {
          id: "data-security",
          title: "9. Data Security",
          paragraphs: [
            "We apply encryption in transit (HTTPS/TLS), bcrypt-hashed passwords, secure httpOnly cookies and JWT authentication with expiration.",
            "Although no system is 100% impenetrable, we maintain reasonable technical and organisational measures aligned with the state of the art.",
          ],
        },
        {
          id: "changes",
          title: "10. Changes to Privacy Policy",
          paragraphs: [
            "This policy may be updated periodically. We will notify substantive changes by email or via a notice on the platform.",
          ],
        },
        {
          id: "contact-info",
          title: "11. Contact Information",
          paragraphs: [
            "Data controller: RE₿EL BTC · Email: rebelbtc@rebelbtc.com · Web: www.rebelbtc.com",
          ],
        },
      ],
    },
    contact: {
      title: "Contact",
      subtitle: "We're here to help. Reach out via the support email and we'll reply within 48 business hours.",
      email_label: "Support Email",
      response_label: "Response time",
      response_time: "Under 48 business hours",
      website_label: "Website",
      categories_title: "Support Categories",
      categories: [
        { title: "Academy Support", desc: "Questions about lessons, quizzes and course content." },
        { title: "AI Mentor Support", desc: "Issues with the Claude Sonnet 4.5 AI Mentor or chat flow." },
        { title: "Payment Support", desc: "Queries about your PRO purchase, billing or Stripe issues." },
        { title: "Technical Support", desc: "Errors, bugs, access problems or improvement suggestions." },
      ],
      cta_label: "Send an Email",
      disclaimer: "RE₿EL BTC provides educational content only. Not financial advice.",
    },
  },

  sk: {
    common: {
      back_home: "Späť na úvod",
      last_updated: "Posledná aktualizácia",
      contact_us: "Kontaktuj nás",
      table_of_contents: "Obsah",
      legal_eyebrow: "Právny dokument",
      educational_disclaimer: "RE₿EL BTC poskytuje výhradne vzdelávací obsah. Nie je to finančné poradenstvo.",
    },
    terms: {
      title: "Podmienky používania",
      subtitle: "Podmienky používania platformy RE₿EL BTC, RE₿EL Akadémie a AI Mentora.",
      sections: [
        {
          id: "educational-purpose",
          title: "1. Vzdelávací účel",
          paragraphs: [
            "RE₿EL BTC je vzdelávacia platforma zameraná na trhy s kryptoaktívami, blockchain, technickú analýzu a riadenie rizika. Všetok obsah — lekcie, grafy, odpovede AI Mentora a články — je poskytovaný výhradne na informačné a vzdelávacie účely.",
            "Používanie platformy nepredstavuje investičné poradenstvo, personalizované odporúčanie ani ponuku na nákup alebo predaj finančných nástrojov či digitálnych aktív.",
          ],
        },
        {
          id: "risk-disclaimer",
          title: "2. Upozornenie na riziko",
          paragraphs: [
            "Obchodovanie a investovanie do kryptoaktív zahŕňa vysokú mieru rizika a môže viesť k úplnej strate kapitálu. Tieto trhy sú vysoko volatilné a minulé výsledky nezaručujú budúce výnosy.",
            "Každý používateľ obchoduje na vlastné rozhodnutie, zodpovednosť a riziko. RE₿EL BTC negarantuje zisky ani neochraňuje pred stratami.",
          ],
        },
        {
          id: "user-accounts",
          title: "3. Používateľské účty",
          paragraphs: [
            "Pre prístup k niektorým funkciám (Akadémia, AI Mentor, Onyx audio) je potrebné vytvoriť si účet s platným emailom a heslom, alebo sa prihlásiť cez Google.",
            "Používateľ je zodpovedný za dôvernosť svojich prihlasovacích údajov a za všetku aktivitu pod svojím účtom. Akýkoľvek neoprávnený prístup okamžite nahláste na rebelbtc@rebelbtc.com.",
          ],
        },
        {
          id: "premium-features",
          title: "4. Prémiové funkcie",
          paragraphs: [
            "Platforma funguje v modeli freemium. 51 lekcií RE₿EL Akadémie je zdarma. AI Mentor a čítanie Onyx hlasom obsahujú jednu (1) doživotnú bezplatnú skúšku na účet.",
            "Pre neobmedzený prístup k týmto funkciám je potrebné zakúpiť jednorazovú licenciu RE₿EL PRO za 39,90 €.",
          ],
        },
        {
          id: "payments",
          title: "5. Platby",
          paragraphs: [
            "Platby spracováva Stripe, poskytovateľ certifikovaný PCI-DSS. RE₿EL BTC neukladá údaje o platobných kartách na svojich serveroch.",
            "Po úspešnej platbe používateľ získa okamžitý a trvalý (doživotný) prístup k zakúpeným PRO funkciám, viazaný na jeho účet.",
          ],
        },
        {
          id: "refund-policy",
          title: "6. Politika vrátenia peňazí",
          paragraphs: [
            "Vzhľadom na digitálnu povahu a okamžitý prístup k produktu sú platby po aktivácii PRO licencie nevratné.",
            "Ak narazíš na technický problém znemožňujúci prístup k zakúpenej službe, kontaktuj nás na rebelbtc@rebelbtc.com do 14 dní od nákupu, aby sme prípad posúdili.",
          ],
        },
        {
          id: "intellectual-property",
          title: "7. Duševné vlastníctvo",
          paragraphs: [
            "Všetok obsah platformy — texty, grafika, lekcie, kód, značka RE₿EL a dizajny — je majetkom RE₿EL BTC a je chránený medzinárodnými zákonmi o duševnom vlastníctve.",
            "Reprodukcia, distribúcia, úprava alebo komerčné použitie bez výslovného písomného súhlasu je zakázané.",
          ],
        },
        {
          id: "ai-mentor",
          title: "8. Upozornenie AI Mentora",
          paragraphs: [
            "AI Mentor je automatizovaný vzdelávací asistent založený na jazykových modeloch. Jeho odpovede môžu obsahovať chyby, nepresnosti alebo zastarané informácie.",
            "AI Mentor za žiadnych okolností nepredstavuje finančné, právne ani daňové poradenstvo. Používateľ musí overiť informácie z oficiálnych zdrojov a u kvalifikovaných odborníkov pred prijatím rozhodnutia.",
          ],
        },
        {
          id: "platform-availability",
          title: "9. Dostupnosť platformy",
          paragraphs: [
            "RE₿EL BTC sa usiluje udržať službu dostupnú 24/7, ale negarantuje úplnú absenciu výpadkov, plánovanej údržby ani technických incidentov.",
            "Vyhradzujeme si právo upraviť, pozastaviť alebo ukončiť funkcie platformy s primeraným oznámením.",
          ],
        },
        {
          id: "limitation-liability",
          title: "10. Obmedzenie zodpovednosti",
          paragraphs: [
            "V maximálnej miere povolenej platnými zákonmi RE₿EL BTC nezodpovedá za priame, nepriame, náhodné ani následné straty vyplývajúce z používania platformy, AI Mentora alebo investičných rozhodnutí.",
            "Používanie platformy je výhradne na vlastné riziko používateľa.",
          ],
        },
        {
          id: "modifications",
          title: "11. Zmeny podmienok",
          paragraphs: [
            "RE₿EL BTC môže tieto Podmienky kedykoľvek aktualizovať. Dátum poslednej aktualizácie je uvedený v hornej časti dokumentu.",
            "Pokračovanie v používaní platformy po zverejnení zmien predstavuje súhlas s novými podmienkami.",
          ],
        },
        {
          id: "contact-info",
          title: "12. Kontaktné informácie",
          paragraphs: [
            "S akoukoľvek otázkou týkajúcou sa týchto Podmienok nás kontaktujte na rebelbtc@rebelbtc.com alebo navštív www.rebelbtc.com.",
          ],
        },
      ],
    },
    privacy: {
      title: "Zásady ochrany osobných údajov",
      subtitle: "Ako zhromažďujeme, používame a chránime tvoje osobné údaje v RE₿EL BTC.",
      sections: [
        {
          id: "info-collected",
          title: "1. Aké informácie zhromažďujeme",
          paragraphs: [
            "Zhromažďujeme len údaje nevyhnutné na poskytovanie služby: email, voliteľné meno, profilová fotka (pri prihlásení cez Google), pokrok v Akadémii a otázky zaslané AI Mentorovi.",
            "Nezhromažďujeme citlivé osobné údaje ani údaje o platobných kartách — tie spracováva výhradne Stripe.",
          ],
        },
        {
          id: "account-data",
          title: "2. Údaje účtu",
          paragraphs: [
            "Tvoj účet uchováva: email, hashované heslo (bcrypt), meno, profilovú fotku, status PRO/FREE, dokončené lekcie a počítadlá použitia skúšky.",
            "Tieto údaje sa uchovávajú počas aktívneho účtu a môžu byť na žiadosť vymazané.",
          ],
        },
        {
          id: "payments-stripe",
          title: "3. Spracovanie platieb cez Stripe",
          paragraphs: [
            "Všetky platby spracováva Stripe Inc., poskytovateľ certifikovaný PCI-DSS úrovne 1. Stripe prijíma údaje o karte priamo z prehliadača používateľa; RE₿EL BTC k nim nikdy nemá prístup.",
            "Stripe spracováva údaje podľa vlastných zásad ochrany súkromia: https://stripe.com/privacy",
          ],
        },
        {
          id: "ai-mentor-data",
          title: "4. Použitie údajov AI Mentora",
          paragraphs: [
            "Správy zaslané AI Mentorovi sa spracovávajú jazykovými modelmi od Anthropic (Claude) pod našim Emergent LLM kľúčom.",
            "Správy sú uložené v našej databáze viazané na tvoj účet výhradne na uchovanie histórie konverzácie v rámci relácie. Nepoužívajú sa na trénovanie externých modelov.",
          ],
        },
        {
          id: "cookies-analytics",
          title: "5. Súbory cookies a analytika",
          paragraphs: [
            "Používame striktne nevyhnutné cookies pre reláciu (httpOnly JWT token) a na zapamätanie tvojho preferovaného jazyka.",
            "Môžeme používať agregovanú analytiku (bez identifikácie jednotlivcov) na zlepšenie platformy. Nepredávame ani neposkytujeme údaje tretím stranám na reklamné účely.",
          ],
        },
        {
          id: "data-protection",
          title: "6. Ochrana údajov",
          paragraphs: [
            "Spracovávame tvoje údaje v súlade s GDPR (Nariadenie (EÚ) 2016/679) a ďalšími platnými predpismi. Právnym základom je súhlas (registrácia) a plnenie zmluvy (PRO služba).",
          ],
        },
        {
          id: "third-parties",
          title: "7. Služby tretích strán",
          paragraphs: [
            "RE₿EL BTC sa spolieha na kvalifikovaných poskytovateľov: Stripe (platby), Anthropic cez Emergent LLM (AI Mentor), OpenAI cez Emergent LLM (Onyx hlasová syntéza), Google (voliteľná autentifikácia) a MongoDB (úložisko).",
            "Každý uplatňuje vlastné záruky bezpečnosti a súkromia.",
          ],
        },
        {
          id: "user-rights",
          title: "8. Práva používateľa",
          paragraphs: [
            "Máš právo na prístup, opravu, vymazanie, prenosnosť a vznesenie námietky proti spracovaniu tvojich údajov. Pre uplatnenie napíš na rebelbtc@rebelbtc.com.",
            "Môžeš tiež podať sťažnosť na príslušný dozorný orgán.",
          ],
        },
        {
          id: "data-security",
          title: "9. Bezpečnosť údajov",
          paragraphs: [
            "Aplikujeme šifrovanie pri prenose (HTTPS/TLS), hashované heslá bcrypt, bezpečné httpOnly cookies a JWT autentifikáciu s vypršaním.",
            "Aj keď žiadny systém nie je 100% nepreniknuteľný, udržujeme primerané technické a organizačné opatrenia v súlade so súčasným stavom techniky.",
          ],
        },
        {
          id: "changes",
          title: "10. Zmeny zásad ochrany súkromia",
          paragraphs: [
            "Tieto zásady môžu byť pravidelne aktualizované. O podstatných zmenách budeme informovať emailom alebo oznámením na platforme.",
          ],
        },
        {
          id: "contact-info",
          title: "11. Kontaktné informácie",
          paragraphs: [
            "Prevádzkovateľ: RE₿EL BTC · Email: rebelbtc@rebelbtc.com · Web: www.rebelbtc.com",
          ],
        },
      ],
    },
    contact: {
      title: "Kontakt",
      subtitle: "Sme tu pre teba. Napíš nám na podporu a odpovieme do 48 pracovných hodín.",
      email_label: "Email podpory",
      response_label: "Čas odozvy",
      response_time: "Do 48 pracovných hodín",
      website_label: "Web",
      categories_title: "Kategórie podpory",
      categories: [
        { title: "Podpora Akadémie", desc: "Otázky k lekciám, kvízom a obsahu kurzu." },
        { title: "Podpora AI Mentora", desc: "Problémy s AI Mentorom Claude Sonnet 4.5 alebo chatom." },
        { title: "Podpora platieb", desc: "Otázky k tvojmu PRO nákupu, fakturácii alebo Stripe." },
        { title: "Technická podpora", desc: "Chyby, bugy, problémy s prístupom alebo návrhy na zlepšenie." },
      ],
      cta_label: "Poslať email",
      disclaimer: "RE₿EL BTC poskytuje výhradne vzdelávací obsah. Nie je to finančné poradenstvo.",
    },
  },

  "zh-CN": {
    common: {
      back_home: "返回首页",
      last_updated: "最后更新",
      contact_us: "联系我们",
      table_of_contents: "目录",
      legal_eyebrow: "法律文件",
      educational_disclaimer: "RE₿EL BTC仅提供教育内容，不构成财务建议。",
    },
    terms: {
      title: "条款与条件",
      subtitle: "RE₿EL BTC平台、RE₿EL学院和AI导师的使用条款。",
      sections: [
        {
          id: "educational-purpose",
          title: "1. 教育目的",
          paragraphs: [
            "RE₿EL BTC是一个专注于加密资产市场、区块链、技术分析和风险管理的教育平台。所有内容——课程、图表、AI导师材料和文章——仅供信息和教育目的。",
            "使用本平台不构成投资咨询、个性化建议或金融工具或数字资产的买卖要约。"
          ],
        },
        {
          id: "risk-disclaimer",
          title: "2. 风险提示",
          paragraphs: [
            "加密资产的交易和投资具有高度风险,可能导致全部资本损失。这些市场的波动性极高,过往表现不保证未来结果。",
            "每位用户根据自己的判断、责任和风险进行操作。RE₿EL BTC不保证收益,也不保护免受损失。"
          ],
        },
        {
          id: "user-accounts",
          title: "3. 用户账户",
          paragraphs: [
            "要访问某些功能(学院、AI导师、Onyx音频),需要通过提供有效电子邮件和密码或通过Google身份验证来创建账户。",
            "用户负责保护其凭证的机密性以及在其账户下进行的所有活动。如发现任何未经授权的访问,请立即通知rebelbtc@rebelbtc.com。"
          ],
        },
        {
          id: "premium-features",
          title: "4. 高级功能",
          paragraphs: [
            "本平台采用免费增值模式。RE₿EL学院的51节课程是免费的。AI导师和Onyx语音朗读为每个账户提供一(1)次终身免费试用。",
            "要无限制访问这些功能,需要购买39.90欧元的RE₿EL PRO一次性付费许可证。"
          ],
        },
        {
          id: "payments",
          title: "5. 付款",
          paragraphs: [
            "付款通过经PCI-DSS认证的Stripe提供商处理。RE₿EL BTC不在其服务器上存储卡数据。",
            "完成付款后,用户将立即获得与其账户关联的PRO功能的永久(终身)访问权限。"
          ],
        },
        {
          id: "refund-policy",
          title: "6. 退款政策",
          paragraphs: [
            "鉴于产品的数字性质和即时访问特性,一旦PRO许可证激活,付款不可退还。",
            "如果您遇到阻止访问所购服务的技术问题,请在购买后14天内通过rebelbtc@rebelbtc.com与我们联系以评估您的情况。"
          ],
        },
        {
          id: "intellectual-property",
          title: "7. 知识产权",
          paragraphs: [
            "平台的所有内容——文本、图表、课程、代码、RE₿EL品牌和设计——均为RE₿EL BTC的财产,并受国际知识产权法保护。",
            "未经书面明确授权,禁止复制、分发、修改或商业再利用。"
          ],
        },
        {
          id: "ai-mentor",
          title: "8. AI导师提示",
          paragraphs: [
            "AI导师是基于语言模型的自动化教育助手。其回答可能包含错误、不准确或过时的信息。",
            "在任何情况下,AI导师都不构成财务、法律或税务建议。用户在做出决定之前,应通过官方来源和认证专业人士验证信息。"
          ],
        },
        {
          id: "platform-availability",
          title: "9. 平台可用性",
          paragraphs: [
            "RE₿EL BTC努力保持服务全天候可用,但不保证完全没有中断、计划维护或技术故障。",
            "我们保留在合理通知的情况下修改、暂停或终止平台功能的权利。"
          ],
        },
        {
          id: "limitation-liability",
          title: "10. 责任限制",
          paragraphs: [
            "在适用法律允许的最大范围内,RE₿EL BTC不对因使用平台、AI导师或投资决策而产生的直接、间接、附带或后果性损失承担责任。",
            "使用平台的风险完全由用户自行承担。"
          ],
        },
        {
          id: "modifications",
          title: "11. 条款修改",
          paragraphs: [
            "RE₿EL BTC可随时更新这些条款。最后更新日期将在文档开头注明。",
            "在发布变更后继续使用平台即构成接受新条款。"
          ],
        },
        {
          id: "contact-info",
          title: "12. 联系信息",
          paragraphs: [
            "如有任何关于这些条款的咨询,请发送电子邮件至rebelbtc@rebelbtc.com或访问www.rebelbtc.com。"
          ],
        }
      ],
    },
    privacy: {
      title: "隐私政策",
      subtitle: "我们如何在RE₿EL BTC收集、使用和保护您的个人数据。",
      sections: [
        {
          id: "info-collected",
          title: "1. 我们收集的信息",
          paragraphs: [
            "我们仅收集提供服务所必需的数据:电子邮件、可选姓名、个人资料照片(如果您通过Google身份验证)、学院进度以及向AI导师提出的咨询。",
            "我们不收集敏感数据或信用卡信息——后者完全由Stripe管理。"
          ],
        },
        {
          id: "account-data",
          title: "2. 账户数据",
          paragraphs: [
            "您的账户存储:电子邮件、加密密码(bcrypt)、姓名、个人资料照片、PRO/FREE状态、已完成课程和试用计数器。",
            "这些数据在您的账户处于活动状态期间保留,并可应要求删除。"
          ],
        },
        {
          id: "payments-stripe",
          title: "3. 通过Stripe处理付款",
          paragraphs: [
            "所有付款均通过经PCI-DSS一级认证的Stripe Inc.处理。Stripe直接从用户浏览器接收卡数据;RE₿EL BTC永远无法访问这些数据。",
            "Stripe根据其自己的隐私政策处理数据:https://stripe.com/privacy"
          ],
        },
        {
          id: "ai-mentor-data",
          title: "4. AI导师数据使用",
          paragraphs: [
            "发送到AI导师的消息通过Anthropic(Claude)提供的语言模型在我们的Emergent密钥下处理。",
            "消息存储在我们的数据库中并与您的账户关联,仅用于在会话中维护对话历史记录。不用于训练外部模型。"
          ],
        },
        {
          id: "cookies-analytics",
          title: "5. Cookie和分析",
          paragraphs: [
            "我们使用严格必要的Cookie用于会话(JWT令牌httpOnly)和记住您的首选语言。",
            "我们可能使用聚合分析(不识别单个用户)来改进平台。我们不出售或向第三方提供用于广告目的的数据。"
          ],
        },
        {
          id: "data-protection",
          title: "6. 数据保护",
          paragraphs: [
            "我们根据GDPR(欧盟第2016/679号条例)和其他适用法规处理您的数据。处理的法律依据是同意(注册)和合同执行(PRO服务)。"
          ],
        },
        {
          id: "third-parties",
          title: "7. 第三方服务",
          paragraphs: [
            "RE₿EL BTC依赖于合格的提供商:Stripe(付款)、通过Emergent LLM的Anthropic(AI导师)、通过Emergent LLM的OpenAI(Onyx语音合成)、Google(可选身份验证)和MongoDB(存储)。",
            "每个提供商都应用自己的安全和隐私保障措施。"
          ],
        },
        {
          id: "user-rights",
          title: "8. 用户权利",
          paragraphs: [
            "您有权访问、更正、删除、携带和反对处理您的数据。要行使这些权利,请发送电子邮件至rebelbtc@rebelbtc.com。",
            "您还可以向主管监管机构(在西班牙为AEPD)提出投诉。"
          ],
        },
        {
          id: "data-security",
          title: "9. 数据安全",
          paragraphs: [
            "我们应用传输加密(HTTPS/TLS)、使用bcrypt的密码哈希、httpOnly安全Cookie以及带有过期时间的JWT身份验证。",
            "虽然不存在100%安全的系统,但我们根据最新技术水平维护合理的技术和组织措施。"
          ],
        },
        {
          id: "changes",
          title: "10. 隐私政策变更",
          paragraphs: [
            "本政策可能会定期更新。我们将通过电子邮件或平台通知告知重大变更。"
          ],
        },
        {
          id: "contact-info",
          title: "11. 联系信息",
          paragraphs: [
            "数据处理负责人:RE₿EL BTC · 电子邮件:rebelbtc@rebelbtc.com · 网站:www.rebelbtc.com"
          ],
        }
      ],
    },
    contact: {
      title: "联系",
      subtitle: "我们随时为您提供帮助。通过支持电子邮件联系我们,我们将在48个工作小时内回复。",
      email_label: "支持电子邮件",
      response_label: "响应时间",
      response_time: "少于48个工作小时",
      website_label: "网站",
      categories_title: "支持类别",
      categories: [
        {
          title: "学院支持",
          desc: "关于课程、测验和课程内容的疑问。",
        },
        {
          title: "AI导师支持",
          desc: "AI导师Claude Sonnet 4.5或聊天流程的问题。",
        },
        {
          title: "付款支持",
          desc: "关于您的PRO购买、账单或Stripe问题的咨询。",
        },
        {
          title: "技术支持",
          desc: "错误、漏洞、访问问题或改进建议。",
        }
      ],
      cta_label: "发送电子邮件",
      disclaimer: "RE₿EL BTC仅提供教育内容,不构成财务建议。",
    },
  },

  de: {
    common: {
      back_home: "Zurück zur Startseite",
      last_updated: "Zuletzt aktualisiert",
      contact_us: "Kontaktiere uns",
      table_of_contents: "Inhaltsverzeichnis",
      legal_eyebrow: "Rechtliches Dokument",
      educational_disclaimer: "RE₿EL BTC bietet ausschließlich Bildungsinhalte. Es handelt sich nicht um Finanzberatung.",
    },
    terms: {
      title: "Allgemeine Geschäftsbedingungen",
      subtitle: "Nutzungsbedingungen der RE₿EL BTC-Plattform, der RE₿EL-Akademie und des IA-Mentors.",
      sections: [
        {
          id: "educational-purpose",
          title: "1. Bildungszweck",
          paragraphs: [
            "RE₿EL BTC ist eine Bildungsplattform, die sich auf Krypto-Asset-Märkte, Blockchain, technische Analyse und Risikomanagement konzentriert. Alle Inhalte – Lektionen, Grafiken, IA-Mentor-Materialien und Artikel – werden ausschließlich zu Informations- und Bildungszwecken bereitgestellt.",
            "Die Nutzung der Plattform stellt keine Anlageberatung, persönliche Empfehlung oder Angebot zum Kauf oder Verkauf von Finanzinstrumenten oder digitalen Assets dar."
          ],
        },
        {
          id: "risk-disclaimer",
          title: "2. Risikohinweis",
          paragraphs: [
            "Der Handel und die Investition in Krypto-Assets bergen ein hohes Risiko und können zu einem Totalverlust des Kapitals führen. Die Volatilität dieser Märkte ist erheblich, und vergangene Renditen garantieren keine zukünftigen Ergebnisse.",
            "Jeder Nutzer handelt nach eigenem Ermessen, auf eigene Verantwortung und eigenes Risiko. RE₿EL BTC garantiert keine Gewinne und schützt nicht vor Verlusten."
          ],
        },
        {
          id: "user-accounts",
          title: "3. Benutzerkonten",
          paragraphs: [
            "Um auf bestimmte Funktionen (Akademie, IA-Mentor, Audio Onyx) zuzugreifen, muss ein Konto durch Angabe einer gültigen E-Mail und eines Passworts oder durch Authentifizierung über Google erstellt werden.",
            "Der Nutzer ist für die Vertraulichkeit seiner Zugangsdaten und alle Aktivitäten unter seinem Konto verantwortlich. Melden Sie jeden unbefugten Zugriff unverzüglich an rebelbtc@rebelbtc.com."
          ],
        },
        {
          id: "premium-features",
          title: "4. Premium-Funktionen",
          paragraphs: [
            "Die Plattform folgt einem Freemium-Modell. Die 51 Lektionen der RE₿EL-Akademie sind kostenlos. Der IA-Mentor und die Onyx-Sprachausgabe beinhalten eine (1) lebenslange kostenlose Testversion pro Konto.",
            "Für unbegrenzten Zugriff auf diese Funktionen ist der Erwerb der RE₿EL PRO-Lizenz zum Einmalpreis von 39,90 € erforderlich."
          ],
        },
        {
          id: "payments",
          title: "5. Zahlungen",
          paragraphs: [
            "Zahlungen werden über Stripe, einen PCI-DSS-zertifizierten Anbieter, abgewickelt. RE₿EL BTC speichert keine Kartendaten auf seinen Servern.",
            "Nach Abschluss der Zahlung erhält der Nutzer sofortigen und dauerhaften (Lifetime-)Zugriff auf die erworbenen PRO-Funktionen, verknüpft mit seinem Konto."
          ],
        },
        {
          id: "refund-policy",
          title: "6. Rückerstattungsrichtlinie",
          paragraphs: [
            "Aufgrund der digitalen Natur und des sofortigen Zugriffs auf das Produkt sind Zahlungen nach Aktivierung der PRO-Lizenz nicht erstattungsfähig.",
            "Wenn Sie ein technisches Problem haben, das den Zugriff auf den erworbenen Service verhindert, kontaktieren Sie uns unter rebelbtc@rebelbtc.com innerhalb von 14 Tagen nach dem Kauf, um den Fall zu prüfen."
          ],
        },
        {
          id: "intellectual-property",
          title: "7. Geistiges Eigentum",
          paragraphs: [
            "Alle Inhalte der Plattform – Texte, Grafiken, Lektionen, Code, RE₿EL-Marke und Designs – sind Eigentum von RE₿EL BTC und durch internationale Gesetze zum Schutz geistigen Eigentums geschützt.",
            "Reproduktion, Verbreitung, Modifikation oder kommerzielle Wiederverwendung ohne ausdrückliche schriftliche Genehmigung sind untersagt."
          ],
        },
        {
          id: "ai-mentor",
          title: "8. Hinweis zum IA-Mentor",
          paragraphs: [
            "Der IA-Mentor ist ein automatisierter Bildungsassistent, der auf Sprachmodellen basiert. Seine Antworten können Fehler, Ungenauigkeiten oder veraltete Informationen enthalten.",
            "Unter keinen Umständen stellt der IA-Mentor Finanz-, Rechts- oder Steuerberatung dar. Der Nutzer muss Informationen mit offiziellen Quellen und akkreditierten Fachleuten validieren, bevor er Entscheidungen trifft."
          ],
        },
        {
          id: "platform-availability",
          title: "9. Verfügbarkeit der Plattform",
          paragraphs: [
            "RE₿EL BTC bemüht sich, den Service 24/7 verfügbar zu halten, garantiert jedoch keine vollständige Abwesenheit von Unterbrechungen, geplanten Wartungsarbeiten oder technischen Störungen.",
            "Wir behalten uns das Recht vor, Funktionen der Plattform mit angemessener Ankündigung zu ändern, auszusetzen oder einzustellen."
          ],
        },
        {
          id: "limitation-liability",
          title: "10. Haftungsbeschränkung",
          paragraphs: [
            "Im größtmöglichen Umfang nach geltendem Recht ist RE₿EL BTC nicht verantwortlich für direkte, indirekte, zufällige oder Folgeschäden, die sich aus der Nutzung der Plattform, des IA-Mentors oder Investitionsentscheidungen ergeben.",
            "Die Nutzung der Plattform erfolgt ausschließlich auf eigenes Risiko des Nutzers."
          ],
        },
        {
          id: "modifications",
          title: "11. Änderungen der Bedingungen",
          paragraphs: [
            "RE₿EL BTC kann diese Bedingungen jederzeit aktualisieren. Das Datum der letzten Aktualisierung ist zu Beginn des Dokuments angegeben.",
            "Die fortgesetzte Nutzung der Plattform nach Veröffentlichung von Änderungen stellt die Annahme der neuen Bedingungen dar."
          ],
        },
        {
          id: "contact-info",
          title: "12. Kontaktinformationen",
          paragraphs: [
            "Für Anfragen bezüglich dieser Bedingungen schreiben Sie uns an rebelbtc@rebelbtc.com oder besuchen Sie www.rebelbtc.com."
          ],
        }
      ],
    },
    privacy: {
      title: "Datenschutzerklärung",
      subtitle: "Wie wir Ihre persönlichen Daten bei RE₿EL BTC sammeln, verwenden und schützen.",
      sections: [
        {
          id: "info-collected",
          title: "1. Informationen, die wir sammeln",
          paragraphs: [
            "Wir sammeln nur die Daten, die unbedingt erforderlich sind, um den Service bereitzustellen: E-Mail, optionaler Name, Profilbild (bei Authentifizierung über Google), Fortschritt in der Akademie und Anfragen an den IA-Mentor.",
            "Wir erfassen keine sensiblen Daten oder Kreditkarteninformationen – Letztere werden ausschließlich von Stripe verwaltet."
          ],
        },
        {
          id: "account-data",
          title: "2. Kontodaten",
          paragraphs: [
            "Ihr Konto speichert: E-Mail, verschlüsseltes Passwort (bcrypt), Name, Profilbild, PRO/FREE-Status, abgeschlossene Lektionen und Testzähler.",
            "Diese Daten werden gespeichert, solange Ihr Konto aktiv ist, und können auf Anfrage gelöscht werden."
          ],
        },
        {
          id: "payments-stripe",
          title: "3. Zahlungsabwicklung über Stripe",
          paragraphs: [
            "Alle Zahlungen werden über Stripe Inc., einem PCI-DSS Level-1-zertifizierten Anbieter, abgewickelt. Stripe erhält Kartendaten direkt vom Browser des Nutzers; RE₿EL BTC hat niemals Zugriff darauf.",
            "Stripe verarbeitet Daten gemäß seiner eigenen Datenschutzerklärung: https://stripe.com/privacy"
          ],
        },
        {
          id: "ai-mentor-data",
          title: "4. Datennutzung des IA-Mentors",
          paragraphs: [
            "An den IA-Mentor gesendete Nachrichten werden über Sprachmodelle von Anthropic (Claude) unter unserem Emergent-Schlüssel verarbeitet.",
            "Nachrichten werden in unserer Datenbank verknüpft mit Ihrem Konto gespeichert, ausschließlich um den Gesprächsverlauf innerhalb der Sitzung zu erhalten. Sie werden nicht zum Training externer Modelle verwendet."
          ],
        },
        {
          id: "cookies-analytics",
          title: "5. Cookies und Analytik",
          paragraphs: [
            "Wir verwenden ausschließlich notwendige Cookies für die Sitzung (JWT-Token httpOnly) und um Ihre bevorzugte Sprache zu speichern.",
            "Wir können aggregierte Analytik (ohne Identifizierung einzelner Nutzer) verwenden, um die Plattform zu verbessern. Wir verkaufen oder geben Daten nicht zu Werbezwecken an Dritte weiter."
          ],
        },
        {
          id: "data-protection",
          title: "6. Datenschutz",
          paragraphs: [
            "Wir verarbeiten Ihre Daten gemäß DSGVO (Verordnung (EU) 2016/679) und anderen anwendbaren Vorschriften. Die Rechtsgrundlage der Verarbeitung ist die Einwilligung (Registrierung) und die Vertragserfüllung (PRO-Service)."
          ],
        },
        {
          id: "third-parties",
          title: "7. Drittanbieter-Services",
          paragraphs: [
            "RE₿EL BTC nutzt qualifizierte Anbieter: Stripe (Zahlungen), Anthropic via Emergent LLM (IA-Mentor), OpenAI via Emergent LLM (Onyx-Sprachsynthese), Google (optionale Authentifizierung) und MongoDB (Speicherung).",
            "Jeder wendet seine eigenen Sicherheits- und Datenschutzgarantien an."
          ],
        },
        {
          id: "user-rights",
          title: "8. Nutzerrechte",
          paragraphs: [
            "Sie haben das Recht auf Zugang, Berichtigung, Löschung, Übertragbarkeit und Widerspruch gegen die Verarbeitung Ihrer Daten. Um diese auszuüben, schreiben Sie uns an rebelbtc@rebelbtc.com.",
            "Sie können auch eine Beschwerde bei der zuständigen Aufsichtsbehörde einreichen (in Spanien die AEPD)."
          ],
        },
        {
          id: "data-security",
          title: "9. Datensicherheit",
          paragraphs: [
            "Wir wenden Transportverschlüsselung (HTTPS/TLS), bcrypt-gehashte Passwörter, sichere httpOnly-Cookies und JWT-Authentifizierung mit Ablauf an.",
            "Obwohl kein System zu 100 % unknackbar ist, halten wir angemessene technische und organisatorische Maßnahmen gemäß dem Stand der Technik ein."
          ],
        },
        {
          id: "changes",
          title: "10. Änderungen der Datenschutzerklärung",
          paragraphs: [
            "Diese Richtlinie kann regelmäßig aktualisiert werden. Wir werden wesentliche Änderungen per E-Mail oder über einen Hinweis auf der Plattform mitteilen."
          ],
        },
        {
          id: "contact-info",
          title: "11. Kontaktinformationen",
          paragraphs: [
            "Verantwortlich für die Verarbeitung: RE₿EL BTC · E-Mail: rebelbtc@rebelbtc.com · Web: www.rebelbtc.com"
          ],
        }
      ],
    },
    contact: {
      title: "Kontakt",
      subtitle: "Wir sind für Sie da. Schreiben Sie uns über die Support-E-Mail und wir antworten innerhalb von 48 Arbeitsstunden.",
      email_label: "Support-E-Mail",
      response_label: "Antwortzeit",
      response_time: "Weniger als 48 Arbeitsstunden",
      website_label: "Web",
      categories_title: "Support-Kategorien",
      categories: [
        {
          title: "Akademie-Support",
          desc: "Fragen zu Lektionen, Quizzes und Kursinhalten.",
        },
        {
          title: "IA-Mentor-Support",
          desc: "Probleme mit dem IA-Mentor Claude Sonnet 4.5 oder dem Chat-Ablauf.",
        },
        {
          title: "Zahlungs-Support",
          desc: "Anfragen zu Ihrem PRO-Kauf, Abrechnung oder Problemen mit Stripe.",
        },
        {
          title: "Technischer Support",
          desc: "Fehler, Bugs, Zugriffsprobleme oder Verbesserungsvorschläge.",
        }
      ],
      cta_label: "E-Mail senden",
      disclaimer: "RE₿EL BTC bietet ausschließlich Bildungsinhalte. Es handelt sich nicht um Finanzberatung.",
    },
  },
};
